export default {"src":"/_next/static/media/bottomCurved_bg_4k.0597e37f.svg","height":1367,"width":3840};